<template>
  <!-- visit-finish -->
  <div class="vf">
    <div class="vf-panel">
      <div class="vf-txt vf-blod">
        请登录pc端展商中心提交和美化店铺及供需对接
      </div>
      <div class="vf-txt vf-pc">
        pc端登录地址
      </div>
      <div class="vf-txt vf-flex">
        {{ shortUrl }}
        <span @click="copy" class="tag-read" :data-clipboard-text="shortUrl">复制地址</span>
      </div>
      <!-- <div class="vf-award-btn" @click="link('home')">返回首页</div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import gql from "graphql-tag";
import Clipboard from "clipboard";

export default {
  // 注册成功页面
  data() {
    return {
      CardId: "",
      VisitorRegRemind: null, // 自定义注册完成描述
      shortUrl: "",
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      exhibitionConfig: "getExhibitionConfig",
    }),
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      LinkFooter: "linkTo/LinkFooter",
      LinkToMyPapers: "linkTo/LinkToMyPapers",
      getShorturl2: "getShorturl",
    }),
    async init() {
      let url = "https://console.zhanshangxiu.com/ex-live/login/ex?id=c0226ba0-881c-43ef-b25a-31b7c32004e2";
      this.shortUrl = await this.getShorturl2(encodeURIComponent(url));
    },
    copy() {
      var clipboard = new Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast.fail("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
    link(type) {
      switch (type) {
        case "home":
          var opt = {
            url: `/home/${this.exhibitionId}`,
          };
          this.LinkFooter(opt);
          break;
        case "card":
          this.LinkToMyPapers();
          break;
        case "head":
          this.$store.commit("setHeadTab", "exinfo");
          var req = {
            url: `/news/${this.exhibitionId}`,
          };
          this.LinkFooter(req);
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.vf {
  &-panel {
    background: #fff;
    padding: 100px 15px 30px;
    img {
      width: 75px;
      display: inline-block;
      margin-bottom: 15px;
    }
  }
  &-txt {
    font-size: 0.28rem;
    line-height: 24px;
    color: #333;
    margin-bottom: 25px;
  }
  &-blod {
    font-weight: 600;
    font-size: 0.32rem;
    margin-bottom: 50px;
  }
  &-pc {
    font-size: 0.26rem;
    color: #999;
  }
  &-flex {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 15px 10px;
    span {
      color: #1890ff;
    }
  }
  &-btn {
    width: 180px;
    line-height: 35px;
    background-color: #0290fe;
    border-radius: 3px;
    color: #fff;
    margin: 0 auto 12px;
    font-size: 15px;
  }
  &-award {
    padding: 10px 15px;
    background: #fff;
    display: flex;
    align-items: center;
    img {
      width: 75px;
      height: 50px;
    }
    &-txt {
      padding: 0 11px;
      font-size: 15px;
      color: #333;
      flex: 1;
    }
    &-btn {
      width: 3.5rem;
      height: 0.92rem;
      text-align: center;
      line-height: 0.92rem;
      border-radius: 3px;
      border: solid 1px #1890ff;
      color: #1890ff;
      font-size: 0.36rem;
      margin: 0.6rem auto 0;
    }
  }
}
</style>
